import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { GET_PLACE_DETAILS } from "../../../../queries/queries/get-place-details.js";
import { fromQueryPlaceDetailsToPlaceDetails } from "../../adapters/hooks/api/adapters/fromQueryPlaceDetailsToPlaceDetails.js";
const usePlaceDetails = () => {
  const [query, queryState] = useLazyQuery(
    GET_PLACE_DETAILS
  );
  const data = React.useMemo(
    () => fromQueryPlaceDetailsToPlaceDetails(queryState.data?.placeDetailsById),
    [queryState.data]
  );
  return React.useMemo(
    () => [
      query,
      {
        ...queryState,
        data
      }
    ],
    [data, queryState, query]
  );
};
export {
  usePlaceDetails
};
//# sourceMappingURL=use-place-details.js.map
